import { showCustomToast } from 'common/components/CustomToast/utils';
import { useMutation } from '@apollo/client';
import { ActionMessageModal } from 'common/components/ActionMessageModal';
import { EntityType } from 'common/types/utility';
import React from 'react';

import { HeaderProps } from '..';
import {
  ChartOfAccountDelete,
  ChartOfAccountDeleteVariables,
} from './__generated__/ChartOfAccountDelete';
import CHART_OF_ACCOUNT_DELETE from './ChartOfAccountDelete.graphql';
import CHART_ACCOUNTING from '../../../../../list/chartAccount/ChartOfAccounts.graphql';

type DeleteChartsOfAccountsProps = HeaderProps;

export const DeleteChartsOfAccounts: React.FC<DeleteChartsOfAccountsProps> = ({
  isEdit,
  data,
  onClose,
}) => {
  const { id, _rowTimestamp, _isDeletable } = { ...data?.chartOfAccount };

  const [deleteChartOfAccount] = useMutation<
    ChartOfAccountDelete,
    ChartOfAccountDeleteVariables
  >(CHART_OF_ACCOUNT_DELETE);

  const onConfirm = async () => {
    if (!!id && !!_rowTimestamp) {
      const { errors } = await deleteChartOfAccount({
        variables: {
          input: {
            entityDelete: [
              {
                id,
                rowTimestamp: _rowTimestamp,
              },
            ],
          },
        },
        awaitRefetchQueries: true,
        refetchQueries: [
          {
            query: CHART_ACCOUNTING,
          },
        ],
      });
      if (errors?.length)
        showCustomToast({
          content: errors[0].message,
          appearance: 'error',
        });
      else {
        showCustomToast({
          content: 'Record Deleted Successfully',
          appearance: 'success',
        });
        onClose();
      }
    }
  };

  if (!isEdit && !_isDeletable) return null;

  return (
    <>
      <ActionMessageModal
        visible={isEdit}
        entityType={EntityType.ChartOfAccount}
        disabled={!_isDeletable}
        onConfirm={onConfirm}
      />
    </>
  );
};
